import {
  Outlet,
  createFileRoute,
  useLocation,
  useNavigate,
} from '@tanstack/react-router';

import type { DealType } from '@/features/contract-and-cost';
import { DealTypeTabs, type DealTabCounts } from '@/features/contract-and-cost';

import { useDealCount } from './-query';

const DEAL_TYPE_TO_PATH: Record<DealType, string> = {
  contract: 'contract',
  estimate: 'estimate',
  order: 'order',
  vendorInvoice: 'vendor-invoice',
  payment: 'payment',
  all: 'all',
};

const DEFAULT_COUNTS: DealTabCounts = {
  contract: 0,
  estimate: 0,
  order: 0,
  vendorInvoice: 0,
  payment: 0,
  all: 0,
};

export const Route = createFileRoute(
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal',
)({
  component: DealLayout,
});

function DealLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = Route.useParams();

  const { data: counts } = useDealCount(id);

  const dealType: DealType = (() => {
    const path = location.pathname;
    if (path.endsWith('/estimate')) return 'estimate';
    if (path.endsWith('/order')) return 'order';
    if (path.endsWith('/vendor-invoice')) return 'vendorInvoice';
    if (path.endsWith('/payment')) return 'payment';
    if (path.endsWith('/all')) return 'all';
    return 'contract';
  })();

  const handleDealTypeChange = (newDealType: DealType) => {
    navigate({
      to: `/device-catalog/active/$id/contract-and-cost/deal/${DEAL_TYPE_TO_PATH[newDealType]}`,
      params: { id },
    });
  };

  return (
    <div className="flex flex-1 flex-col gap-4 px-12 py-5 min-h-0">
      <DealTypeTabs
        value={dealType}
        onValueChange={handleDealTypeChange}
        counts={counts ?? DEFAULT_COUNTS}
      />
      <Outlet />
    </div>
  );
}
